import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import WarningIcon from '@mui/icons-material/Warning';

const RejectedDeviceDialog = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirmation <WarningIcon/></DialogTitle>
    
      <DialogContent>    A device showing up in staged devices already has the desired network access and ELM secrets. If an unexpected device is showing up it’s advised to investigate the same. You can accept a rejected device later. Are you sure you want to reject this device.</DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">Cancel</Button>
        <Button onClick={onConfirm} color="success">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RejectedDeviceDialog;
